import produce from 'immer';

import { ROLE } from '@/core/constants/app-constants';

import {
  clearAuthentication,
  doLogout,
  getGuestUserJwt,
  parseJwtData,
  setAuthentication,
} from '../../utils/auth-utils';
import { createAction } from '../context-utils';
import { AppContextType, Authentication } from './app-context-types';

/** Root Element */
export const setRootElementAction = createAction<AppContextType>((state: AppContextType, payload: any) => {
  return produce(state, (draft) => {
    draft.rootElement = payload.rootElement;
  });
});

/** Authentication */

export const loadTokenAction = createAction<AppContextType>((state: AppContextType, payload: any) => {
  // const authentication: Authentication | null = getAuthentication();
  // getAuthentication().then((authentication: any) => {

  if (payload !== null) {
    return produce(state, (draft) => {
      draft.authentication = payload;
    });
  }
  // else {
  //   return produce(state, (draft) => {
  //     draft.authentication = {
  //       loggedIn: false,
  //       role: getJwtData().role,
  //     };
  //   });
  // }
  // })

  return state;
});

export const loginAction = createAction<AppContextType>((state: AppContextType, payload: any) => {
  const loginData = payload?.loginData;
  const profilesData = payload?.profilesData;

  const authentication: Authentication | null = setAuthentication(loginData, profilesData);
  if (authentication !== null) {
    const base64Payload = loginData.jwt.split('.')[1];
    const jwtPayload: any = JSON.parse(atob(base64Payload));

    // localStorage.setItem('tenant', jwtPayload.tenantId);

    return produce(state, (draft) => {
      draft.authentication = authentication;
      draft.view.loginShownData.isLoginShown = payload?.keepLoginWindow || false;
    });
  }
  return state;
});

export const logoutAction = createAction<AppContextType>((state: AppContextType, payload: any) => {
  // Check if we're on a /web/{websiteID} page
  const currentPath = window.location.pathname;
  const isWebsitePage = /^\/web\/[^/]+$/.test(currentPath);

  clearAuthentication();

  if (isWebsitePage) {
    // For website pages, just clear auth and reload the same page
    getGuestUserJwt()
      .then((response: any) => {
        produce(state, (draft) => {
          draft.authentication = {
            loggedIn: false,
            role: parseJwtData(response).role,
          };
        });

        // Reload the current page instead of redirecting
        // window.location.reload();
      })
      .catch((err) => {
        console.error(err);
        // Even on error, reload the page
        window.location.reload();
      });
  } else {
    // For other pages, use the normal logout flow
    getGuestUserJwt()
      .then((response: any) => {
        produce(state, (draft) => {
          draft.authentication = {
            loggedIn: false,
            role: parseJwtData(response).role,
          };
        });

        doLogout();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return produce(state, (draft) => {
    draft.authentication = {
      loggedIn: false,
      role: ROLE.GUEST,
    };
    draft.view.inEditMode = false;
    draft.view.editOwner = false;
    draft.view.editAssetPortal = false;
    draft.view.editAssetBenefit = false;
    draft.view.editPortalBenefit = false;
  });
});

// export const setSelected = createAction<AppContextType>((state: AppContextType, payload: any) => {
//   return {
//     ...state,
//     view: {
//       ...state.view,
//       selected: action.payload,
//     },
//   };
// })

// export const enableEdit = createAction<AppContextType>((state: AppContextType, payload: any) => {
//   return {
//     ...state,
//     view: {
//       ...state.view,
//       inEditMode: action.payload.inEditMode,
//     },
//   };
// })

// export const setListingQuery = createAction<AppContextType>((state: AppContextType, payload: any) => {
//   return {
//     ...state,
//     data: {
//       ...state.data,
//       listingQuery: action.payload.query,
//     },
//   };
// })

// export const setLoginRedirect = createAction<AppContextType>((state: AppContextType, payload: any) => {
//   setLoginRedirect(action.payload.path)
//   return {
//     ...state
//   }
// })

// export const clearLoginRedirect = createAction<AppContextType>((state: AppContextType, payload: any) => {
//   setLoginRedirect(action.payload.path)
//   clearLoginRedirect()
//   return {
//     ...state
//   }
// })

export const setFeedAction = createAction<AppContextType>((state: AppContextType, payload: any) => {
  return produce(state, (draft) => {
    draft.feed = payload.feed;
  });
});

export const setGuestUserDetailsAction = createAction<AppContextType>(
  (state: AppContextType, payload: any) => {
    return produce(state, (draft) => {
      draft.GuestUserDetails = payload.GuestUserDetails;
    });
  },
);
